import { VueModule } from '@Foundation/utilities';
import Collapse from './code/Scripts/components/collapse.vue';

export default VueModule({
  components: {
    Collapse
  }
});
